export default __webpack_public_path__ + "static/media/step2.709d24b3.svg";